import dayjs from 'dayjs';
import { AdaptoActions } from '@frontend/adapto-actions';
import { formatDate } from '@frontend/date';
import { i18next, useTranslation } from '@frontend/i18n';
import { getFullName } from '@frontend/name';
import { useCalendarEventsConfigurationShallowStore } from '../../../hooks';
import { useAppointmentEventCardShallowStore } from '../../../stores/use-appointment-event-card-store';
import { ExtendedAppointment } from '../../../types';
import { CalendarEventsEnums } from '../../../views/Calendar/types';

export const useOpenAppointmentEditPanel = (appointmentDetails?: ExtendedAppointment | null) => {
  const { setConfiguredCalendarEvent } = useCalendarEventsConfigurationShallowStore('setConfiguredCalendarEvent');

  const openAppointmentEditPanel = (callback?: () => void) => {
    if (!appointmentDetails || !appointmentDetails?.id) {
      return;
    }
    const startDate = dayjs(appointmentDetails?.start);
    const endDate = dayjs(appointmentDetails?.start).add(appointmentDetails?.duration ?? 0, 'm');

    const personName =
      getFullName(appointmentDetails?.person ?? {}) || i18next.t('Unknown', { ns: 'scheduleCalendarEvents' });

    setConfiguredCalendarEvent({
      eventId: appointmentDetails?.id,
      apptStatusV3: appointmentDetails?.statusOfficeView,
      isValid: true,
      calendarDateValue: formatDate(startDate, 'MM/DD/YYYY'),
      locationId: appointmentDetails?.locationId ?? '',
      calendarEventType: CalendarEventsEnums.APPOINTMENT_EVENT,
      startDate: formatDate(startDate, 'MM/DD/YYYY'),
      endDate: formatDate(endDate, 'MM/DD/YYYY'),
      startHour: formatDate(startDate, 'hh:mm A'),
      endHour: formatDate(endDate, 'hh:mm A'),
      providerId: appointmentDetails?.providerIds?.[0] ?? '',
      providerName: appointmentDetails?.practitionerName ?? '',
      name: personName ?? '',
      patientId: appointmentDetails?.person?.personId ?? '',
      createdBySourceId: appointmentDetails?.createdBySourceId ?? '',
      workstationIds: appointmentDetails?.workstationIds ?? [],
      appointmentType: appointmentDetails?.type,
      isNonIntegratedSource: appointmentDetails?.isNonIntegratedSource ?? true,
      referenceId: appointmentDetails?.referenceId ?? '',
      backgroundColor: appointmentDetails.displayOptions?.backgroundColor ?? '',
    });
    callback?.();
  };

  return { openAppointmentEditPanel };
};

export const EditAppointmentActionButton = () => {
  const { t } = useTranslation('schedule');
  const { appointmentDetails, closeAppointmentDetailsModal } = useAppointmentEventCardShallowStore(
    'appointmentDetails',
    'closeAppointmentDetailsModal'
  );

  const { openAppointmentEditPanel } = useOpenAppointmentEditPanel(appointmentDetails);

  return (
    <AdaptoActions.Action
      label={t('Edit Appointment')}
      icon='edit-small'
      onClick={() => openAppointmentEditPanel(closeAppointmentDetailsModal)}
      trackingId='edit-appointment-action-button'
    />
  );
};
